import React, { useRef, useEffect } from "react";

import {
  Text,
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  ButtonGroup,
  IconButton,
} from "@chakra-ui/react";

//import icons
import { FaLinkedin } from "react-icons/fa";
import { AiTwotoneMail } from "react-icons/ai";
import { SiResearchgate } from "react-icons/si";

export default function ContactsForm() {
  const refContainer = useRef(null);
  useEffect(() => {
    refContainer.current.scrollIntoView({ behavior: "smooth" });
  }, []);
  return (
    <Box id="contacts" ref={refContainer}>
      <Box
        width={{
          base: "95%",
          md: "70%",
          xl: "75%",
        }}
        border="10px"
        boxShadow="md"
        p={5}
        background="white"
        marginX="auto"
      >
        <Box>
          <Text fontSize="3xl" fontWeight={700} textAlign="center">
            Get In Touch
          </Text>
        </Box>

        <form>
          <FormControl id="name" margin="1rem" width="96%" isRequired>
            <FormLabel>Name</FormLabel>
            <Input
              type="text"
              name="user_name"
              borderLeft="0"
              borderRight="0"
              borderTop="0"
              borderRadius="none"
              _focus={{
                borderLeft: "0",
                borderRight: "0",
                borderTop: "0",
                borderRadius: "none",
                boxShadow: "none",
                zIndex: "0",
              }}
            />
          </FormControl>

          <FormControl id="email" margin="1rem" width="96%" isRequired>
            <FormLabel>Email address</FormLabel>
            <Input
              type="email"
              name="user_email"
              borderLeft="0"
              borderRight="0"
              borderTop="0"
              borderRadius="none"
              _focus={{
                borderLeft: "0",
                borderRight: "0",
                borderTop: "0",
                borderRadius: "none",
                outline: "none",
                boxShadow: "none",
                zIndex: "0",
              }}
            />
          </FormControl>

          <FormControl id="message" margin="1rem" width="96%" isRequired>
            <FormLabel>Message</FormLabel>
            <Textarea
              name="message"
              type="text"
              padding="1rem"
              size={{
                base: "12.50%", // 0-48em
                md: "25%", // 48em-80em,
                xl: "50%", // 80em+
              }}
              _focus={{
                zIndex: "0",
                padding: "1rem",
                outline: "none",
                boxShadow: "none",
              }}
            />
          </FormControl>
          <Box display="flex" justifyContent="center">
            <Box
              width={{
                base: "100%", // 0-48em
                md: "50%", // 48em-80em,
                xl: "50%", // 80em+
              }}
              alignItems="center"
              as="button"
              mt="2%"
              p={2}
              color="white"
              fontWeight="bold"
              borderRadius="md"
              bgColor="#473198"
              transition="background 0.3s ease-in"
              _hover={{
                bgColor: "black",
                color: "white",
              }}
              name="user_name"
              type="submit"
              value="Send"
            >
              Submit
            </Box>
          </Box>
        </form>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginY="20px"
        >
          <Text fontSize="20px" fontWeight={700}>
            Or Contact Us Through
          </Text>
          <ButtonGroup variant="ghost" gap="20px" marginY="20px">
            <IconButton
              as="a"
              href="#"
              aria-label="LinkedIn"
              icon={<FaLinkedin fontSize="40px" />}
              _focus={{
                zIndex: "0",
              }}
              color="#473198"
            />
            <IconButton
              as="a"
              href="#"
              aria-label="Gmail"
              icon={<AiTwotoneMail fontSize="40px" />}
              _focus={{
                zIndex: "0",
              }}
              color="#473198"
            />
            <IconButton
              as="a"
              href="#"
              aria-label="Researchgate"
              icon={<SiResearchgate fontSize="40px" />}
              _focus={{
                zIndex: "0",
              }}
              color="#473198"
            />
          </ButtonGroup>
        </Box>
      </Box>
    </Box>
  );
}
